import { post } from './http'

// 获取课件列表
export const getCoursewareList = (data) => post(`/api/meas/admin/resource/courseware/getCoursewareList`, data)
// 新增/修改课件信息
export const saveCourseware = (data) => post('/api/meas/admin/resource/courseware/saveCourseware', data)
// 删除课件
export const updateCoursewareStatus = (data) => post('/api/meas/admin/resource/courseware/updateCoursewareStatus', data)
// 获取课件详情
export const getCoursewareDetails = (data) => post('/api/meas/admin/resource/courseware/getCoursewareDetails', data)